import React from "react";
import { motion } from "framer-motion";
import flutter from "../Images/Technologies/flutter.svg"
import js from "../Images/Technologies/js.svg"
import node from "../Images/Technologies/node.svg"
import mongo from "../Images/Technologies/mongo.svg"
import firebase from "../Images/Technologies/firebase.svg"
import react from "../Images/Technologies/react.svg"
import python from "../Images/Technologies/python.svg"
import git from "../Images/Technologies/git.svg"
import s3 from "../Images/Technologies/s3.svg"
import ec2 from "../Images/Technologies/ec2.svg"
import webSocket from "../Images/Technologies/webSocket.svg"
import sql from "../Images/Technologies/sql.svg"
import java from "../Images/Technologies/java.svg"
import meteor from "../Images/Technologies/meteor.svg"
import puppeteer from "../Images/Technologies/puppeteer.svg"
import selenium from "../Images/Technologies/selenium.svg"
import next from "../Images/Technologies/next.svg"
import cloudflaire from "../Images/Technologies/cloudflaire.svg"


const technologies = [
  flutter,
  js,
  node,
  java,
  mongo,
  firebase,
  react,
  meteor,
  puppeteer,
  selenium,
  python,
  cloudflaire,
  git,
  s3,
  ec2,
  sql,
  webSocket,
  next
  // add your tech logos here
];

const TechnologiesSlider = () => {
  return (
    <div className="slider-container">
      <div className="slider-wrapper">
        <motion.div
          className="slider-track"
          initial={{ x: "100%" }}
          animate={{ x: "-100%" }}
          transition={{
            repeat: Infinity,
            duration: 30,
            ease: "linear",
          }}
        >
          {[...technologies, ...technologies].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt="Technology Logo"
              className="slider-logo"
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default TechnologiesSlider;
